import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseService } from '../shared/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CrmService extends BaseService<any> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/crm`, injector);
  }

  getClienteCrm(crmId): Observable<any> {
    return this.http.get(`${environment.API_PRICE}/crm/${crmId}`);
  }

  getClientesCrm(accountId): Observable<any[]> {
    return this.http
      .get<any>(`${environment.API_PRICE}/crm/GetCotacoesByAccountId/${accountId}`)
      .pipe(map((result) => this.normalizarCotacoesCrm(result)));
  }

  /** Aceita array na raiz ou envelope legado { result: [...] }. */
  private normalizarCotacoesCrm(result: any): any[] {
    if (result == null) {
      return [];
    }
    if (Array.isArray(result)) {
      return result;
    }
    const nested = result.result ?? result.items ?? result.data;
    if (Array.isArray(nested)) {
      return nested;
    }
    if (nested && typeof nested === 'object') {
      return [nested];
    }
    if (result.quote_No != null || result.quote_Id != null) {
      return [result];
    }
    return [];
  }
}
